module.exports = __webpack_public_path__ + "media/images/company-logos/universitaetsspital-basel-logo-617013507c8ccb9f23469f1bd5c82dcd.jpg";